// import exampleExtensionInstall from './example';
// import customSeriesExampleExtensionInstall from './series/customExample';
import barExtension from './series/bar/index';
import lineExtension from './series/line/index';
import treemapExtension from './series/treemap/index';
import dvScatterExtension from './series/dvScatter/index';
import dvMarkerExtension from './series/dvMarker/index';
import { yAxisExtensionInstall } from './component/yAxis';
import { install as axisExtension } from './component/axis';
import { install as xAxisExtension } from './component/xAxis';
import { tooltipExtensionInstall } from './component/tooltip';
import { install as dvTwoWayTreeExtension } from './series/dvTwoWayTree';
import { install as axisPointerExtension } from './component/axisPointer';
import { install as dataZoomExtension } from './component/dataZoom1';
import { install as shapePinInstall } from './graphic/Pin';

// * component
export const componentExtensions = [
  axisExtension,
  xAxisExtension,
  yAxisExtensionInstall,
  tooltipExtensionInstall,
  axisPointerExtension,
  dataZoomExtension
];

// * series
export const chartExtensions = [
  // exampleExtensionInstall,
  // customSeriesExampleExtensionInstall,
  ...barExtension,
  ...lineExtension,
  ...treemapExtension,
  ...dvScatterExtension,
  ...dvMarkerExtension,
  dvTwoWayTreeExtension
];

export const graphicExtensions = [shapePinInstall];
